import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { CheckoutPageId } from 'checkout/constants/pages'
import { LUXURY_PLUS } from 'luxPlus/constants/base'

export function useCruiseCheckoutStepLabels(): Record<string, string> {
  const intl = useIntl()
  return useMemo(() => ({
    Passengers: intl.formatMessage({
      id: 'Q8mohzHN3x',
      defaultMessage: 'Passengers',
      description: 'Cruise checkout step label for passenger details',
    }),
    'Type & Category': intl.formatMessage({
      id: 'cIl+X+O470',
      defaultMessage: 'Type & Category',
      description: 'Cruise checkout step label for cabin type and category selection',
    }),
    'Cabin type': intl.formatMessage({
      id: 'KqbiOHj3W+',
      defaultMessage: 'Cabin type',
      description: 'Cruise checkout sub-step label for cabin type selection',
    }),
    'Cabin category': intl.formatMessage({
      id: 'UKuJkpUXyb',
      defaultMessage: 'Cabin category',
      description: 'Cruise checkout sub-step label for cabin category selection',
    }),
    Location: intl.formatMessage({
      id: 'o+n20p4P0Z',
      defaultMessage: 'Location',
      description: 'Cruise checkout step label for cabin location selection',
    }),
    Package: intl.formatMessage({
      id: 'cl53tl3o9Q',
      defaultMessage: 'Package',
      description: 'Cruise checkout step label for cabin package selection',
    }),
    Hotels: intl.formatMessage({
      id: 'bIDjrgvDv/',
      defaultMessage: 'Hotels',
      description: 'Cruise checkout step label for hotel recommendations',
    }),
    'Review & Payment': intl.formatMessage({
      id: 'Togp0Mj8ku',
      defaultMessage: 'Review & Payment',
      description: 'Cruise checkout step label for review and payment',
    }),
  }), [intl])
}

export const CRUISE_CHECKOUT_HEADER_STEPS: Array<App.Checkout.CheckoutStep> = [
  {
    label: 'Passengers',
    key: CheckoutPageId.CruiseTravelers,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'Type & Category',
    key: 'cabin-type-category',
    subSteps: [
      {
        label: 'Cabin type',
        key: CheckoutPageId.CruiseCabinType,
        isRoute: true,
      },
      {
        label: 'Cabin category',
        key: CheckoutPageId.CruiseCabinCategory,
        isRoute: true,
      },
    ],
    isRoute: true,
  },
  {
    label: 'Location',
    key: CheckoutPageId.CruiseCabinLocation,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'Package',
    key: CheckoutPageId.CruiseCabinPackage,
    isRoute: true,
    subSteps: [],
  },
  {
    label: LUXURY_PLUS.PROGRAM_NAME,
    key: CheckoutPageId.LuxPlus,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'Hotels',
    key: CheckoutPageId.CruiseHotelRecommendation,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'Review & Payment',
    key: CheckoutPageId.Purchase,
    subSteps: [],
    isRoute: true,
  },
]
